import Vue from "vue";
import VueRouter, { NavigationGuardNext, RouteConfig } from "vue-router";
import { userModule } from "@/store/modules/user";
import ErrorPage from "@/pages/404.vue";
import formAccessGuard from "@/router/guards/formAccessGuard";
import actingUnitGuard from "@/router/guards/actingUnitGuard";
import { ACTING_UNIT_QUERY } from "@/utils/actingUnit";
import { isPemeriksaanRingkas } from "@/utils/unit";
const ForbiddenPage = () => import("@/pages/Forbidden.vue");
import DaftarPasien from "@/pages/DaftarPasienPage/DaftarPasien.vue";
import Pemeriksaan from "@/pages/Pemeriksaan.vue";
import Login from "@/pages/Login.vue";
import DetailPasien from "@/pages/DetailPasien.vue";
import DaftarPasienRanap from "@/pages/DaftarPasienRanap.vue";
import Report from "@/pages/Report.vue";
import Dashboard from "@/pages/Dashboard.vue";
import DaftarPasienIGD from "@/pages/DaftarPasienIGDPage/DaftarPasienIGD.vue";
import DaftarPasienUnit from "@/pages/DaftarPasienUnitPage/DaftarPasienUnit.vue";
import DaftarPasienPendaftaran from "@/pages/DaftarPasienPendaftaranPage/DaftarPasienPendaftaran.vue";
import { Route } from "vue-router/types/router";
import TindakanMedik from "@/components/pemeriksaan/pelayanan/TindakanMedik.vue";
import AskepRanap from "@/components/pemeriksaan/pelayanan/AskepRanap.vue";
import InputSepPage from "@/pages/InputSepPage.vue";
import InputSepSimplePage from "@/pages/InputSepSimplePage.vue";
import HistoryPesertaWidget from "@/components/bpjs_vclaim/HistoryPesertaWidget.vue";
import RefAskepRanapPage from "@/components/pemeriksaan/RefAskepRanapPage.vue";

// const RekamMedisTabView = () =>
//   import("@/pages/PemeriksaanIgdPage/RekamMedisTabView.vue");
const ResepObatTabView = () =>
  import("@/pages/PemeriksaanIgdPage/ResepObatTabView.vue");
const KonsulRujukanTabView = () =>
  import("@/pages/PemeriksaanIgdPage/KonsulRujukanTabView.vue");
const ResumeSuketTabView = () =>
  import("@/pages/PemeriksaanIgdPage/ResumeSuketTabView.vue");
const PenunjangMedisTabView = () =>
  import("@/pages/PemeriksaanIgdPage/PenunjangMedisTabView.vue");
const PemeriksaanIgd = () =>
  import("@/pages/PemeriksaanIgdPage/PemeriksaanIgd.vue");
// const AsesmenGawatDaruratPage = () =>
//   import("@/pages/PemeriksaanIgdPage/AsesmenGawatDaruratPage.vue");
// const AsuhanKebidananGawatDaruratPage = () =>
//   import("@/pages/PemeriksaanIgdPage/AsuhanKebidananGawatDaruratPage.vue");
const SurveyPrimerIgdPage = () =>
  import("@/pages/PemeriksaanIgdPage/SurveyPrimerIgdPage.vue");
const AsesmenMedisIgdPage = () =>
  import("@/pages/PemeriksaanIgdPage/AsesmenMedisIgdPage.vue");
const AsesmenKeperawatanIgdPage = () =>
  import("@/pages/PemeriksaanIgdPage/AsesmenKeperawatanIgdPage.vue");
const AsesmenRanapMedisIgdPage = () =>
  import("@/pages/PemeriksaanIgdPage/AsesmenRanapMedisIgdPage.vue");
const UserListPage = () => import("@/pages/UserListPage/UserListPage.vue");
const SuperAdminDashboardPage = () =>
  import("@/pages/SuperAdmin/SuperAdminDashboardPage.vue");
const SuperAdminSettingsPage = () =>
  import("@/pages/SuperAdmin/SuperAdminSettingsPage.vue");
const SuperAdminRbacPage = () =>
  import("@/pages/SuperAdmin/SuperAdminRbacPage.vue");
const SuperAdminAuditPage = () =>
  import("@/pages/SuperAdmin/SuperAdminAuditPage.vue");
const PemeriksaanRanap = () => import("@/pages/PemeriksaanRanap.vue");
const PendaftaranPage = () =>
  import("@/pages/PendaftaranPage/PendaftaranPage.vue");
const FeedbackPage = () => import("@/pages/FeedbackPage.vue");
const ListRanap = () => import("@/pages/ListRanap.vue");
const ToolsPage = () => import("@/pages/ToolsPage.vue");
const LoginReportPage = () => import("@/pages/LoginReportPage.vue");
const AuditTrailReportPage = () => import("@/pages/AuditTrailReportPage.vue");
const LaporanRegisterRalanHarianPage = () =>
  import("@/pages/LaporanRegisterRalanHarianPage.vue");
const LaporanPpraPage = () => import("@/pages/LaporanPpraPage.vue");
const OrderGiziDaftarPasienPage = () =>
  import("@/pages/OrderGiziDaftarPasienPage.vue");
const OrderGiziPemesananPage = () =>
  import("@/pages/OrderGiziPemesananPage.vue");
const OrderGiziRekapPage = () => import("@/pages/OrderGiziRekapPage.vue");
const LaporanRekapPersetujuanPasienPage = () =>
  import("@/pages/LaporanRekapPersetujuanPasienPage.vue");
const PermintaanAntimikrobaReservePage = () =>
  import("@/pages/PermintaanAntimikrobaReservePage.vue");
const LaporanKegiatanIgdPage = () =>
  import("@/pages/LaporanKegiatanIgdPage.vue");
const LaporanKegiatanKlinikIgdPage = () =>
  import("@/pages/LaporanKegiatanKlinikIgdPage.vue");
const LaporanRegisterIgdPage = () =>
  import("@/pages/LaporanRegisterIgdPage.vue");
const LaporanLosIgdPage = () => import("@/pages/LaporanLosIgdPage.vue");
const LaporanRekapBulananIgdPage = () =>
  import("@/pages/LaporanRekapBulananIgdPage.vue");
const LaporanIgdMenuPage = () => import("@/pages/LaporanIgdMenuPage.vue");
const LaporanKebidananMenuPage = () =>
  import("@/pages/LaporanKebidananMenuPage.vue");
const LaporanRegisterObstetriPage = () =>
  import("@/pages/LaporanRegisterObstetriPage.vue");
const LaporanRegisterGinekologiPage = () =>
  import("@/pages/LaporanRegisterGinekologiPage.vue");
const LaporanRekapObstetriPage = () =>
  import("@/pages/LaporanRekapObstetriPage.vue");
const LaporanRl36KebidananPage = () =>
  import("@/pages/LaporanRl36KebidananPage.vue");
const LaporanSirsPage = () => import("@/pages/LaporanSirsPage.vue");
const LaporanRl1RanapPage = () => import("@/pages/LaporanRl1RanapPage.vue");
const LaporanBarberJohnsonPage = () =>
  import("@/pages/LaporanBarberJohnsonPage.vue");
const LaporanIndikatorRanapPage = () =>
  import("@/pages/LaporanIndikatorRanapPage.vue");
const LaporanRp1MenuPage = () => import("@/pages/LaporanRp1MenuPage.vue");
const LaporanBankDarahMenuPage = () =>
  import("@/pages/LaporanBankDarahMenuPage.vue");
const LaporanReaksiTransfusiPage = () =>
  import("@/pages/LaporanReaksiTransfusiPage.vue");
const UserProfilePage = () => import("@/pages/UserProfilePage.vue");
const GeneralDocumentPage = () => import("@/pages/GeneralDocumentPage.vue");
const SupervisiAmbulansListPage = () =>
  import("@/pages/mfk/SupervisiAmbulansListPage.vue");
const SupervisiAmbulansFormPage = () =>
  import("@/pages/mfk/SupervisiAmbulansFormPage.vue");
const SupervisiCssdListPage = () =>
  import("@/pages/cssd/SupervisiCssdListPage.vue");
const SupervisiCssdFormPage = () =>
  import("@/pages/cssd/SupervisiCssdFormPage.vue");
const BedManagementListPage = () =>
  import("@/pages/mpp/BedManagementListPage.vue");
const BedManagementFormPage = () =>
  import("@/pages/mpp/BedManagementFormPage.vue");
const SupervisiIbsListPage = () =>
  import("@/pages/ibs/SupervisiIbsListPage.vue");
const SupervisiIbsFormPage = () =>
  import("@/pages/ibs/SupervisiIbsFormPage.vue");
const SupervisiFarmasiListPage = () =>
  import("@/pages/farmasi/SupervisiFarmasiListPage.vue");
const SupervisiFarmasiFormPage = () =>
  import("@/pages/farmasi/SupervisiFarmasiFormPage.vue");
const SupervisiSanitasiListPage = () =>
  import("@/pages/sanitasi/SupervisiSanitasiListPage.vue");
const SupervisiSanitasiFormPage = () =>
  import("@/pages/sanitasi/SupervisiSanitasiFormPage.vue");
const SupervisiBdrsListPage = () =>
  import("@/pages/bdrs/SupervisiBdrsListPage.vue");
const SupervisiBdrsFormPage = () =>
  import("@/pages/bdrs/SupervisiBdrsFormPage.vue");
const IdentitasBayiBaruLahirPage = () =>
  import("@/pages/IdentitasBayiBaruLahirPage.vue");
const PemantauanAnestesiPage = () =>
  import("@/pages/PemantauanAnestesiPage.vue");
const MonitoringIntraOpLokalPage = () =>
  import("@/pages/MonitoringIntraOpLokalPage.vue");
const GiziSupervisiPage = () => import("@/pages/GiziSupervisiPage.vue");
const CpCompliancePage = () => import("@/pages/CpCompliancePage.vue");
const ScEmergencyPage = () => import("@/pages/ScEmergencyPage.vue");
const OutpatientWaitingPage = () => import("@/pages/OutpatientWaitingPage.vue");
const ComplaintResponsePage = () => import("@/pages/ComplaintResponsePage.vue");
const LabSupervisiPage = () => import("@/pages/LabSupervisiPage.vue");
const LaundrySupervisiPage = () => import("@/pages/LaundrySupervisiPage.vue");
const SupervisiUmumPage = () => import("@/pages/SupervisiUmumPage.vue");
const PpiBundleRekapBulananPage = () =>
  import("@/pages/PpiBundleRekapBulananPage.vue");
const PpiRekapSurveilansPage = () =>
  import("@/pages/PpiRekapSurveilansPage.vue");
const PpiRekapAuditPage = () => import("@/pages/PpiRekapAuditPage.vue");
const BerkasRmPage = () => import("@/pages/BerkasRmPage.vue");
const HasilBankDarahPage = () =>
  import("@/pages/bank-darah/HasilBankDarahPage.vue");
const LaporanRekapOrderBankDarahPage = () =>
  import("@/pages/LaporanRekapOrderBankDarahPage.vue");
const LaporanRekapSerahTerimaDarahPage = () =>
  import("@/pages/LaporanRekapSerahTerimaDarahPage.vue");
const LaporanRekapSerahTerimaKantongDarahPage = () =>
  import("@/pages/LaporanRekapSerahTerimaKantongDarahPage.vue");
const SerahTerimaSampelDarahPage = () =>
  import("@/pages/bank-darah/SerahTerimaSampelDarahPage.vue");
const SerahTerimaKantongDarahPage = () =>
  import("@/pages/bank-darah/SerahTerimaKantongDarahPage.vue");
const PembatalanKomponenDarahPage = () =>
  import("@/pages/bank-darah/PembatalanKomponenDarahPage.vue");
const LaporanRekapTransaksiBankDarahPage = () =>
  import("@/pages/LaporanRekapTransaksiBankDarahPage.vue");
const PpiRekapAlatReusePage = () => import("@/pages/PpiRekapAlatReusePage.vue");
const HhSurveilansPage = () => import("@/pages/HhSurveilansPage.vue");
const HhAuditPage = () => import("@/pages/HhAuditPage.vue");
const HhFasilitasAuditPage = () => import("@/pages/HhFasilitasAuditPage.vue");
const InjectionAuditPage = () => import("@/pages/InjectionAuditPage.vue");
const ApdSurveilansPage = () => import("@/pages/ApdSurveilansPage.vue");
const AuditFasilitasApdPage = () => import("@/pages/AuditFasilitasApdPage.vue");
const AuditEtikaBatukPage = () => import("@/pages/AuditEtikaBatukPage.vue");
const AuditLimbahPage = () => import("@/pages/AuditLimbahPage.vue");
const AuditKepatuhanPpiPage = () => import("@/pages/AuditKepatuhanPpiPage.vue");
const AuditKebersihanRuangPage = () =>
  import("@/pages/AuditKebersihanRuangPage.vue");
const AuditKebersihanAlatPage = () =>
  import("@/pages/AuditKebersihanAlatPage.vue");
const AuditMenuPage = () => import("@/pages/AuditMenuPage.vue");
const SurveilansMenuPage = () => import("@/pages/SurveilansMenuPage.vue");
const KeslingMenuPage = () => import("@/pages/KeslingMenuPage.vue");
const AuditKeslingPage = () => import("@/pages/AuditKeslingPage.vue");
const AlatReuseMenuPage = () =>
  import("@/pages/AlatReuse/AlatReuseMenuPage.vue");
const MasterReferensiMenuPage = () =>
  import("@/pages/MasterReferensiMenuPage.vue");
const MasterJenisBerkasPage = () =>
  import("@/pages/MasterJenisBerkasPage.vue");
const MasterAlatReusePage = () =>
  import("@/pages/AlatReuse/MasterAlatReusePage.vue");
const TimPengujiKesehatanPage = () =>
  import("@/pages/Form77/TimPengujiKesehatanPage.vue");
const PenggunaanAlatReusePage = () =>
  import("@/pages/AlatReuse/PenggunaanAlatReusePage.vue");
const KerusakanAlatReusePage = () =>
  import("@/pages/AlatReuse/KerusakanAlatReusePage.vue");
const SupervisiJenazahListPage = () =>
  import("@/pages/supervisi/SupervisiJenazahListPage.vue");
const SupervisiLaundryListPage = () =>
  import("@/pages/supervisi/SupervisiLaundryListPage.vue");
const KepatuhanVisiteDpjpPage = () =>
  import("@/pages/KepatuhanVisiteDpjpPage.vue");
const CriticalLabResultReportingPage = () =>
  import("@/pages/CriticalLabResultReportingPage.vue");
const ScorecardDpjpPage = () => import("@/pages/ScorecardDpjpPage.vue");
const FornasCompliancePage = () => import("@/pages/FornasCompliancePage.vue");
const ElectivePostponementPage = () =>
  import("@/pages/ElectivePostponementPage.vue");
const KepatuhanIdentifikasiPasienPage = () =>
  import("@/pages/KepatuhanIdentifikasiPasienPage.vue");
const KepatuhanJatuhPage = () => import("@/pages/KepatuhanJatuhPage.vue");
const PengajuanAksesRevisiPage = () =>
  import("@/pages/PengajuanAksesRevisiPage.vue");
const DaftarRegisterPasien = () => import("@/pages/DaftarRegisterPasien.vue");
const DashboardDokterPage = () => import("@/pages/DashboardDokterPage.vue");
const RetensiAlihMediaDaftarPage = () =>
  import("@/pages/RetensiAlihMediaDaftarPage.vue");
const RetensiAlihMediaDetailPage = () =>
  import("@/pages/RetensiAlihMediaDetailPage.vue");
const RetensiAlihMediaWizardPage = () =>
  import("@/pages/RetensiAlihMediaWizardPage.vue");
const AuditKuantitatifRmePage = () =>
  import("@/pages/AuditKuantitatifRmePage.vue");

async function requireAuth(to: Route, from: Route, next: NavigationGuardNext) {
  if (!userModule.isSignedIn && to.query?.key && to.query?.user) {
    await userModule.setLogin({
      token: to.query.key.toString(),
      user: JSON.parse(to.query?.user.toString())
    });
    userModule.syncActingUnit(to);
  }

  if (!userModule.isSignedIn) {
    return next({
      path: "/login"
      // query: { redirect: to.fullPath }
    });
  }

  next();
}

async function requireSuperAdmin(
  to: Route,
  from: Route,
  next: NavigationGuardNext
) {
  await requireAuth(to, from, (arg?: Parameters<NavigationGuardNext>[0]) => {
    if (arg !== undefined) return next(arg);
    if (!userModule.isSuperAdmin) return next({ path: "/forbidden" });
    next();
  });
}

async function requireRevisionApprover(
  to: Route,
  from: Route,
  next: NavigationGuardNext
) {
  await requireAuth(to, from, (arg?: Parameters<NavigationGuardNext>[0]) => {
    if (arg !== undefined) return next(arg);
    if (!userModule.canApproveRevisionAccess) {
      return next({
        path: "/forbidden",
        query: { form: "revision_access", action: "approve" }
      });
    }
    next();
  });
}

async function requireAuthPemeriksaanRanap(
  to: Route,
  from: Route,
  next: NavigationGuardNext
) {
  await requireAuth(to, from, (arg?: Parameters<NavigationGuardNext>[0]) => {
    if (arg !== undefined) return next(arg);
    if (!isPemeriksaanRingkas(userModule.user?.unit_id)) return next();

    const query = { ...to.query };
    delete query[ACTING_UNIT_QUERY];

    next({ name: "pemeriksaan", params: to.params, query, replace: true });
  });
}

async function validateRefAskepSession(
  to: Route,
  _from: Route,
  next: NavigationGuardNext
) {
  if (!userModule.isSignedIn && to.query?.key && to.query?.user) {
    await userModule.setLogin({
      token: to.query.key.toString(),
      user: JSON.parse(to.query?.user.toString())
    });
  }

  if (!userModule.isSignedIn) {
    return next({
      path: "/login"
      // query: { redirect: to.fullPath }
    });
  }

  if (!userModule.canAccessRefAskep) {
    return next({ path: "/forbidden", query: { form: "ref_askep" } });
  }

  next();
}

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  { path: "/404", component: ErrorPage, name: "ErrorPage" },
  { path: "/forbidden", component: ForbiddenPage, name: "Forbidden" },

  {
    path: "/cetak/partograf/:register",
    component: () => import("@/components/pemeriksaan/PartografPrint.vue"),
    name: "PartografPrint",
    beforeEnter: requireAuth
  },

  {
    path: "/dashboard-dokter",
    component: DashboardDokterPage,
    name: "dashboard-dokter",
    beforeEnter: requireAuth
  },
  {
    path: "/dashboard-poliklinik",
    component: DaftarPasien,
    name: "dashboard-poliklinik",
    beforeEnter: requireAuth
  },
  {
    path: "/daftar-pasien",
    component: DaftarPasienRanap,
    name: "daftar-pasien",
    beforeEnter: requireAuth
  },
  {
    path: "/daftar-pasien-igd",
    component: DaftarPasienIGD,
    name: "daftar-pasien-igd",
    beforeEnter: requireAuth
  },
  {
    path: "/daftar-pasien-unit",
    component: DaftarPasienUnit,
    name: "daftar-pasien-unit",
    beforeEnter: requireAuth
  },
  {
    path: "/daftar-pasien-pendaftaran",
    component: DaftarPasienPendaftaran,
    name: "daftar-pasien-pendaftaran",
    beforeEnter: requireAuth
  },
  {
    path: "/dashboard-lain",
    component: Dashboard,
    name: "dashboard-lain",
    beforeEnter: requireAuth
  },

  {
    path: "/pendaftaran",
    component: PendaftaranPage,
    name: "pendaftaran"
    // beforeEnter: requireAuth
  },

  // {
  //   path: "/pendaftaran-new",
  //   component: PendaftaranNewPage,
  //   name: "pendaftaran-new",
  //   beforeEnter: requireAuth
  // },

  {
    path: "/input-sep",
    component: InputSepPage,
    name: "input-sep"
  },

  {
    path: "/input-sep-simple",
    component: InputSepSimplePage,
    name: "input-sep-simple"
  },

  {
    path: "/history-peserta-widget",
    component: HistoryPesertaWidget,
    name: "history-peserta-widget"
  },

  // {
  //   path: "/input-sep-widget",
  //   component: InputSepWidgetPage,
  //   name: "input-sep-widget"
  // },

  { path: "/login", component: Login, name: "Login" },
  { path: "*/login", redirect: "/login" },
  { path: "/", redirect: "/login" },
  { path: "*", redirect: "/404" },

  // Page Riwayat Pemeriksaan
  {
    path: "/pemeriksaan/:register/:rm",
    component: Pemeriksaan,
    name: "pemeriksaan",
    beforeEnter: requireAuth
  },

  {
    path: "/pemeriksaan-ranap/:register/:rm",
    component: PemeriksaanRanap,
    name: "pemeriksaan-ranap",
    beforeEnter: requireAuthPemeriksaanRanap
  },

  // Cetak SKDP
  {
    path: "/api-rme/public/api/skdp/:id/pdf",
    name: "cetakSKDP",
    beforeEnter: requireAuth
  },
  // Cetak Surat Konsul
  {
    path: "/api-rme/public/api/surat-konsul/:id/pdf",
    name: "cetakSuratKonsul",
    beforeEnter: requireAuth
  },
  // Cetak Surat Keterangan Diagnosa
  {
    path: "/api-rme/public/api/suket-diagnosa/:id/pdf",
    name: "cetakSkDiagnosa",
    beforeEnter: requireAuth
  },

  {
    path: "/detail-pasien/:rm",
    component: DetailPasien,
    name: "detail-pasien",
    beforeEnter: requireAuth
  },

  {
    path: "/report",
    component: Report,
    name: "report",
    beforeEnter: requireAuth
  },

  {
    path: "/superadmin",
    component: SuperAdminDashboardPage,
    name: "superadmin-dashboard",
    beforeEnter: requireSuperAdmin
  },

  {
    path: "/superadmin/settings",
    component: SuperAdminSettingsPage,
    name: "superadmin-settings",
    beforeEnter: requireSuperAdmin
  },

  {
    path: "/superadmin/rbac",
    component: SuperAdminRbacPage,
    name: "superadmin-rbac",
    beforeEnter: requireSuperAdmin
  },

  {
    path: "/superadmin/audit",
    component: SuperAdminAuditPage,
    name: "superadmin-audit",
    meta: { privilege: { domain: "audit_trail" } },
    beforeEnter: requireAuth
  },

  {
    path: "/user-list",
    component: UserListPage,
    name: "user-list",
    beforeEnter: requireAuth
  },

  {
    path: "/tindakan",
    component: TindakanMedik,
    name: "tindakan",
    beforeEnter: requireAuth
  },

  {
    path: "/input-billing",
    component: TindakanMedik,
    name: "input-billing",
    beforeEnter: requireAuth
  },

  {
    path: "/askep-ranap",
    component: AskepRanap,
    name: "askep-ranap",
    meta: { privilege: { domain: "perencanaan-askep", action: "view" } },
    beforeEnter: requireAuth
  },

  {
    path: "/ref-askep",
    component: RefAskepRanapPage,
    name: "ref-askep",
    beforeEnter: validateRefAskepSession
  },

  {
    path: "/feedback",
    component: FeedbackPage,
    name: "feedback",
    beforeEnter: requireAuth
  },

  {
    path: "/general-document",
    component: GeneralDocumentPage,
    name: "general-document",
    meta: { privilege: { domain: "master_general_document" } },
    beforeEnter: requireAuth
  },

  {
    path: "/supervisi/jenazah",
    component: SupervisiJenazahListPage,
    name: "supervisi-jenazah",
    meta: { privilege: { domain: "supervisi_jenazah" } },
    beforeEnter: requireAuth
  },
  {
    path: "/supervisi/laundry",
    component: SupervisiLaundryListPage,
    name: "supervisi-laundry",
    meta: { privilege: { domain: "supervisi_laundry" } },
    beforeEnter: requireAuth
  },

  {
    path: "/list-ranap",
    component: ListRanap,
    name: "list-ranap",
    beforeEnter: requireAuth
  },

  {
    path: "/tools",
    component: ToolsPage,
    name: "tools",
    beforeEnter: requireAuth
  },

  // {
  //   path: "/setting",
  //   component: UserListPage,
  //   name: "setting",
  //   beforeEnter: requireAuth
  // },

  {
    path: "/report/login-report",
    component: LoginReportPage,
    name: "login-report",
    beforeEnter: requireAuth
  },

  {
    path: "/report/audit-trail",
    component: AuditTrailReportPage,
    name: "audit-trail-report"
  },

  {
    path: "/report/register-ralan-harian",
    component: LaporanRegisterRalanHarianPage,
    name: "register-ralan-harian",
    beforeEnter: requireAuth
  },

  {
    path: "/report/ppra",
    component: LaporanPpraPage,
    name: "laporan-ppra",
    meta: { privilege: { domain: "laporan_ppra" } },
    beforeEnter: requireAuth
  },

  {
    path: "/order-gizi/daftar-pasien",
    component: OrderGiziDaftarPasienPage,
    name: "order-gizi-daftar-pasien",
    meta: { formAccess: { code: "order_gizi_daftar_pasien" } },
    beforeEnter: requireAuth
  },

  {
    path: "/order-gizi/pemesanan",
    component: OrderGiziPemesananPage,
    name: "order-gizi-pemesanan",
    meta: { formAccess: { code: "order_gizi_pemesanan" } },
    beforeEnter: requireAuth
  },

  {
    path: "/order-gizi/rekap",
    component: OrderGiziRekapPage,
    name: "order-gizi-rekap",
    meta: { formAccess: { code: "order_gizi_rekap" } },
    beforeEnter: requireAuth
  },

  {
    path: "/report/rekap-persetujuan-pasien",
    component: LaporanRekapPersetujuanPasienPage,
    name: "laporan-rekap-persetujuan-pasien",
    meta: { privilege: { domain: "laporan_persetujuan_pasien" } },
    beforeEnter: requireAuth
  },

  {
    path: "/permintaan-antimikroba-reserve",
    component: PermintaanAntimikrobaReservePage,
    name: "permintaan-antimikroba-reserve",
    meta: { privilege: { domain: "antimikroba_reserve" } },
    beforeEnter: requireAuth
  },

  {
    path: "/report/kegiatan-igd",
    component: LaporanKegiatanIgdPage,
    name: "laporan-kegiatan-igd",
    meta: { privilege: { domain: "laporan_kegiatan_igd" } },
    beforeEnter: requireAuth
  },

  {
    path: "/report/kegiatan-klinik-igd",
    component: LaporanKegiatanKlinikIgdPage,
    name: "laporan-kegiatan-klinik-igd",
    meta: { privilege: { domain: "laporan_kegiatan_klinik_igd" } },
    beforeEnter: requireAuth
  },

  {
    path: "/report/register-igd",
    component: LaporanRegisterIgdPage,
    name: "laporan-register-igd",
    meta: { privilege: { domain: "laporan_register_igd" } },
    beforeEnter: requireAuth
  },

  {
    path: "/report/los-igd",
    component: LaporanLosIgdPage,
    name: "laporan-los-igd",
    meta: { privilege: { domain: "laporan_los_igd" } },
    beforeEnter: requireAuth
  },

  {
    path: "/report/rekap-bulanan-igd",
    component: LaporanRekapBulananIgdPage,
    name: "laporan-rekap-bulanan-igd",
    meta: { privilege: { domain: "laporan_rekap_bulanan_igd" } },
    beforeEnter: requireAuth
  },

  {
    path: "/report/igd",
    component: LaporanIgdMenuPage,
    name: "laporan-igd-menu",
    beforeEnter: requireAuth
  },

  {
    path: "/report/kebidanan",
    component: LaporanKebidananMenuPage,
    name: "laporan-kebidanan-menu",
    beforeEnter: requireAuth
  },

  {
    path: "/report/kebidanan/register-obstetri",
    component: LaporanRegisterObstetriPage,
    name: "laporan-register-obstetri",
    meta: { privilege: { domain: "laporan_register_obstetri" } },
    beforeEnter: requireAuth
  },

  {
    path: "/report/kebidanan/register-ginekologi",
    component: LaporanRegisterGinekologiPage,
    name: "laporan-register-ginekologi",
    meta: { privilege: { domain: "laporan_register_ginekologi" } },
    beforeEnter: requireAuth
  },

  {
    path: "/report/kebidanan/rekap-obstetri",
    component: LaporanRekapObstetriPage,
    name: "laporan-rekap-obstetri",
    meta: { privilege: { domain: "laporan_rekap_obstetri" } },
    beforeEnter: requireAuth
  },

  {
    path: "/report/kebidanan/rl36",
    component: LaporanRl36KebidananPage,
    name: "laporan-rl36-kebidanan",
    meta: { privilege: { domain: "laporan_rl36_kebidanan" } },
    beforeEnter: requireAuth
  },

  {
    path: "/report/sirs",
    component: LaporanSirsPage,
    name: "laporan-sirs",
    beforeEnter: requireAuth
  },

  {
    path: "/report/rp1",
    component: LaporanRp1MenuPage,
    name: "laporan-rp1-menu",
    beforeEnter: requireAuth
  },

  {
    path: "/report/bank-darah",
    component: LaporanBankDarahMenuPage,
    name: "laporan-bank-darah-menu",
    meta: { privilege: { domain: "laporan_bank_darah" } },
    beforeEnter: requireAuth
  },

  {
    path: "/report/bank-darah/reaksi-transfusi",
    component: LaporanReaksiTransfusiPage,
    name: "laporan-reaksi-transfusi",
    meta: { privilege: { domain: "laporan_bank_darah" } },
    beforeEnter: requireAuth
  },

  {
    path: "/report/bank-darah/rekap-order",
    component: LaporanRekapOrderBankDarahPage,
    name: "laporan-rekap-order-bank-darah",
    meta: { privilege: { domain: "laporan_bank_darah" } },
    beforeEnter: requireAuth
  },

  {
    path: "/report/bank-darah/rekap-serah-terima",
    component: LaporanRekapSerahTerimaDarahPage,
    name: "laporan-rekap-serah-terima-darah",
    meta: { privilege: { domain: "laporan_bank_darah" } },
    beforeEnter: requireAuth
  },

  {
    path: "/report/bank-darah/rekap-serah-terima-kantong",
    component: LaporanRekapSerahTerimaKantongDarahPage,
    name: "laporan-rekap-serah-terima-kantong-darah",
    meta: { privilege: { domain: "laporan_bank_darah" } },
    beforeEnter: requireAuth
  },

  {
    path: "/report/bank-darah/rekap-transaksi",
    component: LaporanRekapTransaksiBankDarahPage,
    name: "laporan-rekap-transaksi-bank-darah",
    meta: { privilege: { domain: "laporan_bank_darah" } },
    beforeEnter: requireAuth
  },

  {
    path: "/report/rl1-ranap",
    component: LaporanRl1RanapPage,
    name: "rl1-ranap",
    beforeEnter: requireAuth
  },

  {
    path: "/report/barber-johnson",
    component: LaporanBarberJohnsonPage,
    name: "laporan-barber-johnson",
    beforeEnter: requireAuth
  },

  {
    path: "/report/indikator-ranap",
    component: LaporanIndikatorRanapPage,
    name: "laporan-indikator-ranap",
    beforeEnter: requireAuth
  },

  {
    path: "/user-profile",
    component: UserProfilePage,
    name: "user-profile",
    beforeEnter: requireAuth
  },

  {
    path: "/mfk/supervisi-ambulans",
    component: SupervisiAmbulansListPage,
    name: "supervisi-ambulans-list",
    meta: { privilege: { domain: "supervisi_ambulan" } },
    beforeEnter: requireAuth
  },
  {
    path: "/mfk/supervisi-ambulans/:id",
    component: SupervisiAmbulansFormPage,
    name: "supervisi-ambulans-form",
    meta: { privilege: { domain: "supervisi_ambulan" } },
    beforeEnter: requireAuth
  },

  {
    path: "/cssd/supervisi",
    component: SupervisiCssdListPage,
    name: "supervisi-cssd-list",
    meta: { privilege: { domain: "supervisi_cssd" } },
    beforeEnter: requireAuth
  },
  {
    path: "/cssd/supervisi/:id",
    component: SupervisiCssdFormPage,
    name: "supervisi-cssd-form",
    meta: { privilege: { domain: "supervisi_cssd" } },
    beforeEnter: requireAuth
  },

  {
    path: "/mpp/bed-management",
    component: BedManagementListPage,
    name: "bed-management-list",
    meta: { privilege: { domain: "mpp_bed_management" } },
    beforeEnter: requireAuth
  },
  {
    path: "/mpp/bed-management/:id",
    component: BedManagementFormPage,
    name: "bed-management-form",
    meta: { privilege: { domain: "mpp_bed_management" } },
    beforeEnter: requireAuth
  },

  {
    path: "/ibs/supervisi",
    component: SupervisiIbsListPage,
    name: "supervisi-ibs-list",
    meta: { privilege: { domain: "supervisi_ibs" } },
    beforeEnter: requireAuth
  },
  {
    path: "/ibs/supervisi/:id",
    component: SupervisiIbsFormPage,
    name: "supervisi-ibs-form",
    meta: { privilege: { domain: "supervisi_ibs" } },
    beforeEnter: requireAuth
  },

  {
    path: "/farmasi/supervisi",
    component: SupervisiFarmasiListPage,
    name: "supervisi-farmasi-list",
    meta: { privilege: { domain: "supervisi_farmasi" } },
    beforeEnter: requireAuth
  },
  {
    path: "/farmasi/supervisi/:id",
    component: SupervisiFarmasiFormPage,
    name: "supervisi-farmasi-form",
    meta: { privilege: { domain: "supervisi_farmasi" } },
    beforeEnter: requireAuth
  },

  {
    path: "/sanitasi/supervisi",
    component: SupervisiSanitasiListPage,
    name: "supervisi-sanitasi-list",
    meta: { privilege: { domain: "supervisi_sanitasi" } },
    beforeEnter: requireAuth
  },
  {
    path: "/sanitasi/supervisi/:id",
    component: SupervisiSanitasiFormPage,
    name: "supervisi-sanitasi-form",
    meta: { privilege: { domain: "supervisi_sanitasi" } },
    beforeEnter: requireAuth
  },
  {
    path: "/bdrs/supervisi",
    component: SupervisiBdrsListPage,
    name: "supervisi-bdrs-list",
    meta: { privilege: { domain: "supervisi_bdrs" } },
    beforeEnter: requireAuth
  },
  {
    path: "/bdrs/supervisi/:id",
    component: SupervisiBdrsFormPage,
    name: "supervisi-bdrs-form",
    meta: { privilege: { domain: "supervisi_bdrs" } },
    beforeEnter: requireAuth
  },
  {
    path: "/identitas-bayi-baru-lahir/:register/:rm",
    component: IdentitasBayiBaruLahirPage,
    name: "identitas-bayi-baru-lahir",
    beforeEnter: requireAuth,
    props: true
  },
  {
    path: "/pemantauan-anestesi/:register/:rm",
    component: PemantauanAnestesiPage,
    name: "pemantauan-anestesi",
    beforeEnter: requireAuth,
    props: true
  },
  {
    path: "/monitoring-intra-op-lokal/:register/:rm",
    component: MonitoringIntraOpLokalPage,
    name: "monitoring-intra-op-lokal",
    beforeEnter: requireAuth,
    props: true
  },
  {
    path: "/gizi-supervisi",
    component: GiziSupervisiPage,
    name: "gizi-supervisi",
    meta: { privilege: { domain: "supervisi_gizi" } },
    beforeEnter: requireAuth
  },
  {
    path: "/lab-supervisi",
    component: LabSupervisiPage,
    name: "lab-supervisi",
    meta: { privilege: { domain: "supervisi_lab" } },
    beforeEnter: requireAuth
  },
  {
    path: "/laundry-supervisi",
    component: LaundrySupervisiPage,
    name: "laundry-supervisi",
    meta: { privilege: { domain: "supervisi_laundry" } },
    beforeEnter: requireAuth
  },
  {
    path: "/ppi-supervisi-umum",
    component: SupervisiUmumPage,
    name: "ppi-supervisi-umum",
    meta: { privilege: { domain: "supervisi_umum" } },
    beforeEnter: requireAuth
  },
  {
    path: "/ppi-bundle-rekap-bulanan",
    component: PpiBundleRekapBulananPage,
    name: "ppi-bundle-rekap-bulanan",
    meta: { privilege: { domain: "ppi_bundle_rekap_bulanan" } },
    beforeEnter: requireAuth
  },
  {
    path: "/ppi-rekap-alat-reuse",
    component: PpiRekapAlatReusePage,
    name: "ppi-rekap-alat-reuse",
    meta: { privilege: { domain: "ppi_bundle_rekap_bulanan" } },
    beforeEnter: requireAuth
  },
  {
    path: "/ppi-rekap",
    redirect: { name: "ppi-rekap-surveilans" }
  },
  {
    path: "/ppi-rekap-surveilans",
    component: PpiRekapSurveilansPage,
    name: "ppi-rekap-surveilans",
    meta: { privilege: { domain: "ppi_rekap_ruangan" } },
    beforeEnter: requireAuth
  },
  {
    path: "/ppi-rekap-audit",
    component: PpiRekapAuditPage,
    name: "ppi-rekap-audit",
    meta: { privilege: { domain: "ppi_rekap_ruangan" } },
    beforeEnter: requireAuth
  },
  {
    path: "/berkas-rm",
    component: BerkasRmPage,
    name: "berkas-rm",
    beforeEnter: requireAuth
  },
  {
    path: "/bank-darah/hasil",
    component: HasilBankDarahPage,
    name: "bank-darah-hasil",
    beforeEnter: requireAuth
  },
  {
    path: "/bank-darah/order",
    name: "bank-darah-order",
    redirect: { name: "daftar-pasien" }
  },
  {
    path: "/bank-darah/serah-terima-sampel",
    component: SerahTerimaSampelDarahPage,
    name: "bank-darah-serah-terima-sampel",
    meta: { privilege: { domain: "bank_darah_order" } },
    beforeEnter: requireAuth
  },
  {
    path: "/bank-darah/serah-terima-kantong",
    component: SerahTerimaKantongDarahPage,
    name: "bank-darah-serah-terima-kantong",
    meta: { privilege: { domain: "bank_darah_order" } },
    beforeEnter: requireAuth
  },
  {
    path: "/bank-darah/pembatalan-komponen",
    component: PembatalanKomponenDarahPage,
    name: "bank-darah-pembatalan-komponen",
    meta: { privilege: { domain: "bank_darah_order" } },
    beforeEnter: requireAuth
  },
  {
    path: "/master-referensi",
    component: MasterReferensiMenuPage,
    name: "master-referensi-menu",
    beforeEnter: requireAuth
  },
  {
    path: "/master/jenis-berkas",
    component: MasterJenisBerkasPage,
    name: "master-jenis-berkas",
    meta: { privilege: { domain: "master_jenis_berkas" } },
    beforeEnter: requireAuth
  },
  {
    path: "/ppi-audit",
    component: AuditMenuPage,
    name: "ppi-audit-menu",
    beforeEnter: requireAuth
  },
  {
    path: "/ppi-surveilans",
    component: SurveilansMenuPage,
    name: "ppi-surveilans-menu",
    beforeEnter: requireAuth
  },
  {
    path: "/ppi-hh-surveilans",
    component: HhSurveilansPage,
    name: "ppi-hh-surveilans",
    meta: { privilege: { domain: "surveilans_hh" } },
    beforeEnter: requireAuth
  },
  {
    path: "/ppi-hh-audit",
    component: HhAuditPage,
    name: "ppi-hh-audit",
    meta: { privilege: { domain: "audit_hh" } },
    beforeEnter: requireAuth
  },
  {
    path: "/ppi-hh-fasilitas-audit",
    component: HhFasilitasAuditPage,
    name: "ppi-hh-fasilitas-audit",
    meta: { privilege: { domain: "audit_hh" } },
    beforeEnter: requireAuth
  },
  {
    path: "/ppi-injection-audit",
    component: InjectionAuditPage,
    name: "ppi-injection-audit",
    meta: { privilege: { domain: "audit_penyuntikan_aman" } },
    beforeEnter: requireAuth
  },
  {
    path: "/ppi-apd-surveilans",
    component: ApdSurveilansPage,
    name: "ppi-apd-surveilans",
    meta: { privilege: { domain: "surveilans_apd" } },
    beforeEnter: requireAuth
  },
  {
    path: "/ppi-audit-fasilitas-apd",
    component: AuditFasilitasApdPage,
    name: "ppi-audit-fasilitas-apd",
    meta: { privilege: { domain: "audit_apd" } },
    beforeEnter: requireAuth
  },
  {
    path: "/ppi-audit-etika-batuk",
    component: AuditEtikaBatukPage,
    name: "ppi-audit-etika-batuk",
    meta: { privilege: { domain: "audit_etika_batuk" } },
    beforeEnter: requireAuth
  },
  {
    path: "/ppi-audit-limbah",
    component: AuditLimbahPage,
    name: "ppi-audit-limbah",
    meta: { privilege: { domain: "audit_limbah" } },
    beforeEnter: requireAuth
  },
  {
    path: "/ppi-audit-kepatuhan",
    component: AuditKepatuhanPpiPage,
    name: "ppi-audit-kepatuhan",
    meta: { privilege: { domain: "audit_kepatuhan_ppi" } },
    beforeEnter: requireAuth
  },
  {
    path: "/ppi-audit-kebersihan-ruang",
    component: AuditKebersihanRuangPage,
    name: "ppi-audit-kebersihan-ruang",
    meta: { privilege: { domain: "audit_kebersihan_ruang" } },
    beforeEnter: requireAuth
  },
  {
    path: "/ppi-audit-kebersihan-alat",
    component: AuditKebersihanAlatPage,
    name: "ppi-audit-kebersihan-alat",
    meta: { privilege: { domain: "audit_kebersihan_alat" } },
    beforeEnter: requireAuth
  },
  {
    path: "/kesling",
    component: KeslingMenuPage,
    name: "kesling",
    beforeEnter: requireAuth
  },
  {
    path: "/kesling-audit",
    component: AuditKeslingPage,
    name: "kesling-audit",
    meta: { privilege: { domain: "audit_lingkungan" } },
    beforeEnter: requireAuth
  },
  {
    path: "/alat-reuse",
    component: AlatReuseMenuPage,
    name: "alat-reuse",
    beforeEnter: requireAuth
  },
  {
    path: "/tim-penguji-kesehatan",
    component: TimPengujiKesehatanPage,
    name: "tim-penguji-kesehatan",
    meta: { privilege: { domain: "master_tim_penguji" } },
    beforeEnter: requireAuth
  },
  {
    path: "/alat-reuse/master",
    component: MasterAlatReusePage,
    name: "alat-reuse-master",
    meta: { privilege: { domain: "master_alat_reuse" } },
    beforeEnter: requireAuth
  },
  {
    path: "/alat-reuse/penggunaan",
    component: PenggunaanAlatReusePage,
    name: "alat-reuse-penggunaan",
    beforeEnter: requireAuth
  },
  {
    path: "/alat-reuse/kerusakan",
    component: KerusakanAlatReusePage,
    name: "alat-reuse-kerusakan",
    beforeEnter: requireAuth
  },
  {
    path: "/kepatuhan-visite-dpjp",
    component: KepatuhanVisiteDpjpPage,
    name: "kepatuhan-visite-dpjp",
    meta: { privilege: { domain: "mutu_visite_dokter" } },
    beforeEnter: requireAuth
  },
  {
    path: "/scorecard-dpjp",
    redirect: { name: "kepatuhan-visite-dpjp", query: { tab: "scorecard" } }
  },
  {
    path: "/pelaporan-hasil-kritis-lab",
    component: CriticalLabResultReportingPage,
    name: "pelaporan-hasil-kritis-lab",
    meta: { privilege: { domain: "mutu_hasil_kritis_lab" } },
    beforeEnter: requireAuth
  },
  {
    path: "/kepatuhan-fornas",
    component: FornasCompliancePage,
    name: "kepatuhan-fornas",
    meta: { privilege: { domain: "mutu_fornas" } },
    beforeEnter: requireAuth
  },
  {
    path: "/penundaan-operasi-elektif",
    component: ElectivePostponementPage,
    name: "penundaan-operasi-elektif",
    meta: { privilege: { domain: "mutu_penundaan_operasi" } },
    beforeEnter: requireAuth
  },
  {
    path: "/pengajuan-akses-revisi",
    component: PengajuanAksesRevisiPage,
    name: "pengajuan-akses-revisi",
    beforeEnter: requireRevisionApprover
  },
  {
    path: "/daftar-register-pasien",
    component: DaftarRegisterPasien,
    name: "daftar-register-pasien",
    beforeEnter: requireAuth
  },
  {
    path: "/daftar-pasien-administrasi",
    component: DaftarRegisterPasien,
    name: "daftar-pasien-administrasi",
    meta: { daftarRegisterMode: "administrasi" },
    beforeEnter: requireAuth
  },
  {
    path: "/daftar-pasien-akan-datang",
    component: () => import("@/pages/DaftarPasienAkanDatang.vue"),
    name: "daftar-pasien-akan-datang",
    beforeEnter: requireAuth
  },
  {
    path: "/kepatuhan-identifikasi-pasien",
    component: KepatuhanIdentifikasiPasienPage,
    name: "kepatuhan-identifikasi-pasien",
    meta: { privilege: { domain: "mutu_identifikasi_pasien" } },
    beforeEnter: requireAuth
  },
  {
    path: "/kepatuhan-jatuh",
    component: KepatuhanJatuhPage,
    name: "kepatuhan-jatuh",
    meta: { privilege: { domain: "mutu_pencegahan_jatuh" } },
    beforeEnter: requireAuth
  },
  {
    path: "/urm/retensi-alih-media",
    component: RetensiAlihMediaDaftarPage,
    name: "RetensiAlihMediaDaftar",
    beforeEnter: requireAuth
  },
  {
    path: "/urm/retensi-alih-media/wizard",
    component: RetensiAlihMediaWizardPage,
    name: "RetensiAlihMediaWizard",
    beforeEnter: requireAuth
  },
  {
    path: "/urm/retensi-alih-media/:id",
    component: RetensiAlihMediaDetailPage,
    name: "RetensiAlihMediaDetail",
    beforeEnter: requireAuth
  },
  {
    path: "/mrmik/audit-kuantitatif-rme",
    component: AuditKuantitatifRmePage,
    name: "audit-kuantitatif-rme",
    beforeEnter: requireAuth
  },
  {
    path: "/mutu/cp-compliance",
    component: CpCompliancePage,
    name: "cp-compliance",
    meta: { privilege: { domain: "mutu_clinical_pathway" } },
    beforeEnter: requireAuth
  },
  {
    path: "/mutu/sc-emergency",
    component: ScEmergencyPage,
    name: "sc-emergency",
    meta: { privilege: { domain: "mutu_waktu_tanggap_sc" } },
    beforeEnter: requireAuth
  },
  {
    path: "/mutu/outpatient-waiting",
    component: OutpatientWaitingPage,
    name: "outpatient-waiting",
    meta: { privilege: { domain: "mutu_waktu_tunggu_ralan" } },
    beforeEnter: requireAuth
  },
  {
    path: "/mutu/komplain",
    component: ComplaintResponsePage,
    name: "complaint-response",
    meta: { privilege: { domain: "mutu_tanggap_komplain" } },
    beforeEnter: requireAuth
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  // base: __dirname,
  routes
});

// Unit bertindak — WAJIB terdaftar sebelum formAccessGuard (lihat guard-nya).
router.beforeEach(actingUnitGuard);

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.profesi === "Dokter")) {
    if (userModule.user.profesi === "Dokter") {
      return next();
    } else {
      alert("hanya dokter yang bisa mengakses halaman ini!");

      return next({
        name: "pemeriksaan-igd.resume-suket",
        params: to.params
      });
    }
  }

  next();
});

// Global formAccessGuard — gating route berbasis (unit_id, profesi) via canAccessForm.
// Setiap route yang butuh gating tambahkan meta.formAccess = { code, action } / { code, actions: [...] }.
router.beforeEach(formAccessGuard);

export default router;

